export const data = [
  {
    id: 1,
    title: "Eau De Parfum",
    image:
      "https://s3-alpha-sig.figma.com/img/a362/df95/6e6296cbe1c6d4f8267e0525156d320c?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=lxz6NUYjkuc35vsJgKLowoj4n1BRzszjmn-0Ja9HhGmTBLqFqfOPFF4OrToBf1Cl-VZgtm1HU88l2oG~MsfVSVvz0449n3xButxCr6op2L320fCEfaTV65M3r-Qo1FHYelCKt1RcxUpL0fiuRmS8rh5NaXK45w9ebWLHDyGekZjsKg1FiGUs0oI3yq5xZu5RWVFXpahm21D~xPd2pE8i9JqlUI-TOhMY-pTTDQ0qYVbPTeDDDG5s9nsVKyQG6JC0VniD5yJC2NN-gKXXlnJ3pmIWWIqVtsjBDIu64rWOQ29SY2sxqu40fEkc7hcrwrHGlqMDjsGGQv87WY4~u6WGJQ__",
    desc: "mid night wispers 50 ml.",
    price: " $35",
    gender: "women",
    arrivalTime: "2023-12-01T09:00:00.000Z",
  },
  {
    id: 2,
    title: "detect 2 perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/92fc/6852/174a240c2f50a4e0d7ad10555bd3ff16?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=pg1ZvU-~PWDRTfYcsEHMswoAXzRwdxI-Bg0-G9YphD755GleFBr4XL7zWb9m-y3mfl7ZEjW1X9JArbrZ2cxqWLA0OjT~bAXT19bNSvaKfdUDd2~CyfmzsHSvTOTHQQpsZp-ZunjFxJDzFDJN5QixvnCdJy28uj0Bzxact9i6j5vCW27~0WcXfDONBaHtYDeasxG8LLDZu6Nq3iGRmm9ij4gswpanjDrouDIlsJlWlgQBZbXhpZ-FbP8IJIQZ4fIFq502SI7KseuVDoYvRSQ3NCtSDTauEibaFtmzAKF0Wr~YdnfjLvs1iMutuRSUn8P7QoJxjSXoX9ZmuUtlOQF1Mg__",
    desc: "mid night wispers 50 ml.",
    price: " $35",
    gender: "women",
    arrivalTime: "2024-02-01T09:00:00.000Z",
  },
  {
    id: 3,
    title: "Vke eau de perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/c670/b843/c108f28fb69ea06fde0eb13a11db1141?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=c7lOa8RQ3VV~vWLiv3HQy9LjiBwGXerD0sXZJiZAM5QU5I~PBGoGxx47Fny3nTnK8lhT-9rIGW5UJ~w6XxWQpvNZ3lW6P7Py0txUsWwQQdTg1VkId0OGmW4GN9mfVWdzAGUw-3dqI6Ya1BoU75dpJuSN3D2Hq5sGoxsonsEYCZLcwWH2NAalaWeBqsGdsG7SpJ2TeZ1UXP-~2V6NhsFidmnXl6JQi01Za~7BcCoighY90NC6qThj5UOXtzC75QQLivHiri1oldKRd4cRVYS8M6QJntjM6WWnvr1~TYHpYpbq7Gr79cBrXaQitEOeixkEUPhUK1tqmwCWtf7tM-STVA__",
    desc: "mid night wispers 50 ml.",
    price: " $35",
    gender: "men",
    arrivalTime: "2023-11-01T03:00:00.000Z",
  },
  {
    id: 4,
    title: "Vke eau de perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/375a/bca1/aa296cf5601ff172ae6d978a945238aa?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Va1IDuAcsjX2p8MiJ-ZUmTeFPp9fK2w3HqkTAIiMuRuYMggVKytYjFJAK0m4L1PCCXdJ6anyP53hcPRxxkvvjvoOw26-zaeIOHbcmcz3v5Aq0fm2XSQR-hcVJo-fhIqESuLlH93Vp5KC1e2X0fUkuWrCzR~4bQ9tiyg~pf1NwLOltxCiKnm7CqUmZ2yfRpFVKxf-1UatdwhHP~SBGIp8cTy9-CK7iUxQO6PDJ75n4Wdiawcx4XmRZP~jrMYE5kJBV1-sWpz8lhPQmXpdc-U07qPFZhWHTrN2XkEGNn19nUYmRGW~92zT~BIq1tjYDjYJufnSvnYM5tDPBS9eXDqiDQ__",
    desc: "mid night wispers 50 ml.",
    price: " $35",
    gender: "men",
    arrivalTime: "2024-02-01T09:00:00.000Z",
  },
  {
    id: 5,
    title: "Vke eau de perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/ab95/238b/408548e45612ab97698171267dd9112b?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=RsI-YXgHF7jM-ty6Oo073FhltQLVNOYDD~59gUmwHKQ-GmJS2MQIGcoGkf7~mW-xHFLVSKpg3MIqXw-HHtyrC9558fNuLYVtZLmzG5j~RxoXHaezpBtqeULyUKcQsvu5jjBAFeFyL-QG3dZM3tFaCTVKURnI5WOaImjqlqkndWNQW5xG-G8d3Ruyj-Jy2w3QFbrvf9MbU6H420oaq3SFkb28ZHkTovXS2CKMgWTNGfkFAvXXQSsYOHov0Xda5x57hi04NCbQfYnwTO6pUAm7AH6qciFWE7~amaPcZCPFZeTCtFopGdFBkPL1uPrqfxTbvHlcNFLBj1edOhoDJc8UpQ__",
    desc: "mid night wispers 50 ml.",
    price: " $35",
    gender: "men",
    arrivalTime: "2024-01-01T09:00:00.000Z",
  },
  {
    id: 6,
    title: "Vke eau de perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/a362/df95/6e6296cbe1c6d4f8267e0525156d320c?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=lxz6NUYjkuc35vsJgKLowoj4n1BRzszjmn-0Ja9HhGmTBLqFqfOPFF4OrToBf1Cl-VZgtm1HU88l2oG~MsfVSVvz0449n3xButxCr6op2L320fCEfaTV65M3r-Qo1FHYelCKt1RcxUpL0fiuRmS8rh5NaXK45w9ebWLHDyGekZjsKg1FiGUs0oI3yq5xZu5RWVFXpahm21D~xPd2pE8i9JqlUI-TOhMY-pTTDQ0qYVbPTeDDDG5s9nsVKyQG6JC0VniD5yJC2NN-gKXXlnJ3pmIWWIqVtsjBDIu64rWOQ29SY2sxqu40fEkc7hcrwrHGlqMDjsGGQv87WY4~u6WGJQ__",
    desc: "mid night wispers 50 ml.",
    price: " $35",
    gender: "women",
    arrivalTime: "2024-01-01T04:00:00.000Z",
  },
  {
    id: 7,
    title: "Vke eau de perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/9c3e/c5af/ff78793c366e31af2599113ab329fcf3?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Icp-PadkuU5CAErj1s4JUiZeIetK-oIlce5-jgt4FSrQ-OvyX0UNGlTtB7ADECJoP7jW1oRQRFhFMGlJGaKcA9cJcZGnl2ohgF--PAfYI7qRtpKUz2zqMSJDEWknEBWujiZjw32MF8FV8Q7hAX6H2XPfeGbcqsWjY6KVnZm59Rrjwq5XMgvouJd1SkHLNEp2vV0Q~0RzpuEie1i1PMXxnhYyFQ4JSg8pvDq4qUWFw6OiHXf3y8hneMfXhpIW45zJqCO5sbGeGNPdwq4hK7T6yU21YPXFImE1V31XNuHsHkRHF~gcByuLU-MxLqpTGmUPW6bsAGO~v5XqKjGJwkYPeQ__",
    desc: "mid night wispers 50 ml.",
    price: " $35",
    gender: "women",
    arrivalTime: "2023-09-01T09:00:00.000Z",
  },
  {
    id: 8,
    title: "Vke eau de perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/375a/bca1/aa296cf5601ff172ae6d978a945238aa?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Va1IDuAcsjX2p8MiJ-ZUmTeFPp9fK2w3HqkTAIiMuRuYMggVKytYjFJAK0m4L1PCCXdJ6anyP53hcPRxxkvvjvoOw26-zaeIOHbcmcz3v5Aq0fm2XSQR-hcVJo-fhIqESuLlH93Vp5KC1e2X0fUkuWrCzR~4bQ9tiyg~pf1NwLOltxCiKnm7CqUmZ2yfRpFVKxf-1UatdwhHP~SBGIp8cTy9-CK7iUxQO6PDJ75n4Wdiawcx4XmRZP~jrMYE5kJBV1-sWpz8lhPQmXpdc-U07qPFZhWHTrN2XkEGNn19nUYmRGW~92zT~BIq1tjYDjYJufnSvnYM5tDPBS9eXDqiDQ__",
    desc: "mid night wispers 50 ml.",
    price: " $35",
    gender: "men",
    arrivalTime: "2023-10-01T12:00:00.000Z",
  },
  {
    id: 9,
    title: "Vke eau de perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/ab95/238b/408548e45612ab97698171267dd9112b?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=RsI-YXgHF7jM-ty6Oo073FhltQLVNOYDD~59gUmwHKQ-GmJS2MQIGcoGkf7~mW-xHFLVSKpg3MIqXw-HHtyrC9558fNuLYVtZLmzG5j~RxoXHaezpBtqeULyUKcQsvu5jjBAFeFyL-QG3dZM3tFaCTVKURnI5WOaImjqlqkndWNQW5xG-G8d3Ruyj-Jy2w3QFbrvf9MbU6H420oaq3SFkb28ZHkTovXS2CKMgWTNGfkFAvXXQSsYOHov0Xda5x57hi04NCbQfYnwTO6pUAm7AH6qciFWE7~amaPcZCPFZeTCtFopGdFBkPL1uPrqfxTbvHlcNFLBj1edOhoDJc8UpQ__",
    desc: "midnight whispers 50 ml.",
    price: "$35",
    gender: "women",
    arrivalTime: "2023-08-01T15:00:00.000Z",
  },
  {
    id: 10,
    title: "Vke eau de perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/a362/df95/6e6296cbe1c6d4f8267e0525156d320c?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=lxz6NUYjkuc35vsJgKLowoj4n1BRzszjmn-0Ja9HhGmTBLqFqfOPFF4OrToBf1Cl-VZgtm1HU88l2oG~MsfVSVvz0449n3xButxCr6op2L320fCEfaTV65M3r-Qo1FHYelCKt1RcxUpL0fiuRmS8rh5NaXK45w9ebWLHDyGekZjsKg1FiGUs0oI3yq5xZu5RWVFXpahm21D~xPd2pE8i9JqlUI-TOhMY-pTTDQ0qYVbPTeDDDG5s9nsVKyQG6JC0VniD5yJC2NN-gKXXlnJ3pmIWWIqVtsjBDIu64rWOQ29SY2sxqu40fEkc7hcrwrHGlqMDjsGGQv87WY4~u6WGJQ__",
    desc: "midnight whispers 50 ml.",
    price: "$35",
    gender: "men",
    arrivalTime: "2023-07-01T21:00:00.000Z",
  },
  {
    id: 11,
    title: "Vke eau de perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/9c3e/c5af/ff78793c366e31af2599113ab329fcf3?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Icp-PadkuU5CAErj1s4JUiZeIetK-oIlce5-jgt4FSrQ-OvyX0UNGlTtB7ADECJoP7jW1oRQRFhFMGlJGaKcA9cJcZGnl2ohgF--PAfYI7qRtpKUz2zqMSJDEWknEBWujiZjw32MF8FV8Q7hAX6H2XPfeGbcqsWjY6KVnZm59Rrjwq5XMgvouJd1SkHLNEp2vV0Q~0RzpuEie1i1PMXxnhYyFQ4JSg8pvDq4qUWFw6OiHXf3y8hneMfXhpIW45zJqCO5sbGeGNPdwq4hK7T6yU21YPXFImE1V31XNuHsHkRHF~gcByuLU-MxLqpTGmUPW6bsAGO~v5XqKjGJwkYPeQ__",
    desc: "midnight whispers 50 ml.",
    price: "$35",
    gender: "women",
    arrivalTime: "2024-04-01T09:00:00.000Z",
  },
  {
    id: 12,
    title: "Vke eau de perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/c670/b843/c108f28fb69ea06fde0eb13a11db1141?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=c7lOa8RQ3VV~vWLiv3HQy9LjiBwGXerD0sXZJiZAM5QU5I~PBGoGxx47Fny3nTnK8lhT-9rIGW5UJ~w6XxWQpvNZ3lW6P7Py0txUsWwQQdTg1VkId0OGmW4GN9mfVWdzAGUw-3dqI6Ya1BoU75dpJuSN3D2Hq5sGoxsonsEYCZLcwWH2NAalaWeBqsGdsG7SpJ2TeZ1UXP-~2V6NhsFidmnXl6JQi01Za~7BcCoighY90NC6qThj5UOXtzC75QQLivHiri1oldKRd4cRVYS8M6QJntjM6WWnvr1~TYHpYpbq7Gr79cBrXaQitEOeixkEUPhUK1tqmwCWtf7tM-STVA__",
    desc: "midnight whispers 50 ml.",
    price: "$35",
    gender: "men",
    arrivalTime: "2024-03-01T18:00:00.000Z",
  },
  {
    id: 13,
    title: "Vke eau de perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/92fc/6852/174a240c2f50a4e0d7ad10555bd3ff16?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=pg1ZvU-~PWDRTfYcsEHMswoAXzRwdxI-Bg0-G9YphD755GleFBr4XL7zWb9m-y3mfl7ZEjW1X9JArbrZ2cxqWLA0OjT~bAXT19bNSvaKfdUDd2~CyfmzsHSvTOTHQQpsZp-ZunjFxJDzFDJN5QixvnCdJy28uj0Bzxact9i6j5vCW27~0WcXfDONBaHtYDeasxG8LLDZu6Nq3iGRmm9ij4gswpanjDrouDIlsJlWlgQBZbXhpZ-FbP8IJIQZ4fIFq502SI7KseuVDoYvRSQ3NCtSDTauEibaFtmzAKF0Wr~YdnfjLvs1iMutuRSUn8P7QoJxjSXoX9ZmuUtlOQF1Mg__",
    desc: "midnight whispers 50 ml.",
    price: "$35",
    gender: "men",
    arrivalTime: "2024-05-01T09:00:00.000Z",
  },
  {
    id: 14,
    title: "Vke eau de perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/375a/bca1/aa296cf5601ff172ae6d978a945238aa?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Va1IDuAcsjX2p8MiJ-ZUmTeFPp9fK2w3HqkTAIiMuRuYMggVKytYjFJAK0m4L1PCCXdJ6anyP53hcPRxxkvvjvoOw26-zaeIOHbcmcz3v5Aq0fm2XSQR-hcVJo-fhIqESuLlH93Vp5KC1e2X0fUkuWrCzR~4bQ9tiyg~pf1NwLOltxCiKnm7CqUmZ2yfRpFVKxf-1UatdwhHP~SBGIp8cTy9-CK7iUxQO6PDJ75n4Wdiawcx4XmRZP~jrMYE5kJBV1-sWpz8lhPQmXpdc-U07qPFZhWHTrN2XkEGNn19nUYmRGW~92zT~BIq1tjYDjYJufnSvnYM5tDPBS9eXDqiDQ__",
    desc: "midnight whispers 50 ml.",
    price: "$35",
    gender: "men",
    arrivalTime: "2024-06-01T09:00:00.000Z",
  },
  {
    id: 15,
    title: "Vke eau de perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/a362/df95/6e6296cbe1c6d4f8267e0525156d320c?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=lxz6NUYjkuc35vsJgKLowoj4n1BRzszjmn-0Ja9HhGmTBLqFqfOPFF4OrToBf1Cl-VZgtm1HU88l2oG~MsfVSVvz0449n3xButxCr6op2L320fCEfaTV65M3r-Qo1FHYelCKt1RcxUpL0fiuRmS8rh5NaXK45w9ebWLHDyGekZjsKg1FiGUs0oI3yq5xZu5RWVFXpahm21D~xPd2pE8i9JqlUI-TOhMY-pTTDQ0qYVbPTeDDDG5s9nsVKyQG6JC0VniD5yJC2NN-gKXXlnJ3pmIWWIqVtsjBDIu64rWOQ29SY2sxqu40fEkc7hcrwrHGlqMDjsGGQv87WY4~u6WGJQ__",
    desc: "midnight whispers 50 ml.",
    price: "$35",
    gender: "women",
    arrivalTime: "2024-07-01T04:00:00.000Z",
  },
  {
    id: 16,
    title: "Vke eau de perfume",
    image:
      "https://s3-alpha-sig.figma.com/img/9c3e/c5af/ff78793c366e31af2599113ab329fcf3?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Icp-PadkuU5CAErj1s4JUiZeIetK-oIlce5-jgt4FSrQ-OvyX0UNGlTtB7ADECJoP7jW1oRQRFhFMGlJGaKcA9cJcZGnl2ohgF--PAfYI7qRtpKUz2zqMSJDEWknEBWujiZjw32MF8FV8Q7hAX6H2XPfeGbcqsWjY6KVnZm59Rrjwq5XMgvouJd1SkHLNEp2vV0Q~0RzpuEie1i1PMXxnhYyFQ4JSg8pvDq4qUWFw6OiHXf3y8hneMfXhpIW45zJqCO5sbGeGNPdwq4hK7T6yU21YPXFImE1V31XNuHsHkRHF~gcByuLU-MxLqpTGmUPW6bsAGO~v5XqKjGJwkYPeQ__",
    desc: "midnight whispers 50 ml.",
    price: "$35",
    gender: "women",
    arrivalTime: "2024-08-01T09:00:00.000Z",
  },
  {
    id: 17,
    title: "L'Essence de Presence",
    image:
      "https://s3-alpha-sig.figma.com/img/a362/df95/6e6296cbe1c6d4f8267e0525156d320c?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=lxz6NUYjkuc35vsJgKLowoj4n1BRzszjmn-0Ja9HhGmTBLqFqfOPFF4OrToBf1Cl-VZgtm1HU88l2oG~MsfVSVvz0449n3xButxCr6op2L320fCEfaTV65M3r-Qo1FHYelCKt1RcxUpL0fiuRmS8rh5NaXK45w9ebWLHDyGekZjsKg1FiGUs0oI3yq5xZu5RWVFXpahm21D~xPd2pE8i9JqlUI-TOhMY-pTTDQ0qYVbPTeDDDG5s9nsVKyQG6JC0VniD5yJC2NN-gKXXlnJ3pmIWWIqVtsjBDIu64rWOQ29SY2sxqu40fEkc7hcrwrHGlqMDjsGGQv87WY4~u6WGJQ__",
    desc: "A floral harmony blended with natural essences.",
    price: "$48",
    gender: "women",
    arrivalTime: "2024-09-01T10:00:00.000Z",
  },
  {
    id: 18,
    title: "Oceanic Breeze",
    image:
      "https://s3-alpha-sig.figma.com/img/9c3e/c5af/ff78793c366e31af2599113ab329fcf3?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Icp-PadkuU5CAErj1s4JUiZeIetK-oIlce5-jgt4FSrQ-OvyX0UNGlTtB7ADECJoP7jW1oRQRFhFMGlJGaKcA9cJcZGnl2ohgF--PAfYI7qRtpKUz2zqMSJDEWknEBWujiZjw32MF8FV8Q7hAX6H2XPfeGbcqsWjY6KVnZm59Rrjwq5XMgvouJd1SkHLNEp2vV0Q~0RzpuEie1i1PMXxnhYyFQ4JSg8pvDq4qUWFw6OiHXf3y8hneMfXhpIW45zJqCO5sbGeGNPdwq4hK7T6yU21YPXFImE1V31XNuHsHkRHF~gcByuLU-MxLqpTGmUPW6bsAGO~v5XqKjGJwkYPeQ__",
    desc: "Refreshing aquatic scents for an invigorating experience.",
    price: "$42",
    gender: "men",
    arrivalTime: "2024-10-01T11:00:00.000Z",
  },
  {
    id: 19,
    title: "Velvet Mystique",
    image:
      "https://s3-alpha-sig.figma.com/img/92fc/6852/174a240c2f50a4e0d7ad10555bd3ff16?Expires=1710115200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=pg1ZvU-~PWDRTfYcsEHMswoAXzRwdxI-Bg0-G9YphD755GleFBr4XL7zWb9m-y3mfl7ZEjW1X9JArbrZ2cxqWLA0OjT~bAXT19bNSvaKfdUDd2~CyfmzsHSvTOTHQQpsZp-ZunjFxJDzFDJN5QixvnCdJy28uj0Bzxact9i6j5vCW27~0WcXfDONBaHtYDeasxG8LLDZu6Nq3iGRmm9ij4gswpanjDrouDIlsJlWlgQBZbXhpZ-FbP8IJIQZ4fIFq502SI7KseuVDoYvRSQ3NCtSDTauEibaFtmzAKF0Wr~YdnfjLvs1iMutuRSUn8P7QoJxjSXoX9ZmuUtlOQF1Mg__",
    desc: "A luxurious blend of musk and velvet scents.",
    price: "$55",
    gender: "women",
    arrivalTime: "2024-11-01T12:00:00.000Z",
  },
  // Add more entries as needed
];
